export enum AmlVerificationStatus {
  NotInProgress = 0,
  SourceOfWealthQuestionnaire = 1,
  SourceOfWealthSupportingDocs = 2,
  SourceOfFunds = 3,
}
